import { SimpleCall } from '@cian/frontend-newbuilding-call-component';
import { EPageTypes, EPlatformTypes } from '@cian/frontend-dynamic-calltracking-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { SinglePhoneComponent } from '../../components/SinglePhoneComponent';
import { getSellers } from '../../selectors/newbuilding';
import { useApplicationContext } from '../../utils/applicationContext';

interface ILeadFactoryCallButtonContainerProps {
  placeType: string;
  size: 'M' | 'XS';
}

// TODO: Написать тесты, когда появится эксперимент в CD-199899.
/* istanbul ignore next */
export const LeadFactoryCallButtonContainer: React.FC<ILeadFactoryCallButtonContainerProps> = ({ placeType, size }) => {
  const sellers = useSelector(getSellers);
  const { httpApi, logger } = useApplicationContext();

  const styles = { size, fullWidth: true };

  return (
    <SimpleCall
      builders={[]}
      sellers={sellers}
      openContactsStyles={styles}
      showPhoneStyles={styles}
      httpApi={httpApi}
      logger={logger}
      onShowPhoneClick={() => {}} // TODO: Добавить аналитику в CD-199907.
      pageType={EPageTypes.NewbuildingCard}
      platformType={EPlatformTypes.WebDesktop}
      placeType={placeType}
      singlePhoneButtonText="Позвонить консультанту"
      multiplePhoneButtonText="Позвонить консультанту"
      withoutModal={true}
      SinglePhoneComponent={size === 'M' ? SinglePhoneComponent : undefined}
    />
  );
};
